import React, { Component } from 'react'
import './imd-student-winners.scss'
import SchoolUserApi from '../../../apis/student'
import Loading from '../../common/loading/loading'
import PaginationComponent from '../../common/cw-pagination/cw-pagination-v2'
import { Constants } from '../../../constants/constants'
import IMDStudentWinnersList from './imd-student-winners-list'

class IMDStudentWinners extends Component {
  constructor (props) {
    super(props)
  }

  getIMDWinnersList = (payload = {}) => {
    this.studentWinners.getIMDWinnersList(payload);
  }

  render () {
    return (
      <>
        <div className='winners-list'>
          <div className='row'>
            <div className='col'>
              <div className='cw-plain-card cw-plain-card-wrapper-top mr-2 mb-3'>
                <div className='cw-plain-card-wrapper-winners'>
                  <IMDStudentWinnersList
                    selectedClass={this.props.selectedClass}
                    ref={instance => {
                      this.studentWinners = instance
                    }}
                    gmcAllowed={this.props.gmcAllowed}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </>
    )
  }
}

export default IMDStudentWinners
